import type { IconName } from '@epilot/concorde-elements'
import type { Design } from '@epilot/journey-logic-commons'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { useEffect } from 'react'

import { includeCommon } from '../../../utils/includeCommon'

export type LinkedJourney = {
  id: string
  label: string
  icon: IconName | null
  design?: Design
}

export type JourneyLauncherControlOptions = {
  linkedJourneys: LinkedJourney[]
}

/**
 * @todo Remove once we're sure the control is never getting rendered,
 * by inspecting the datadog logs
 */
const JourneyLauncherControl = () => {
  useEffect(() => {
    console.error(new Error('JourneyLauncherControl is should not be rendered'))
  }, [])

  return null
}

export default withJsonFormsControlProps(
  includeCommon({
    component: JourneyLauncherControl
  }) as never
)
